module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/vectors/term-bg-2-b0041c48293e33f92854d90f71c0ce77.jpg";